import React, { Component } from 'react';
import './index.css';
import AuthService from '../../components/AuthService';
import { createBrowserHistory } from 'history';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const history = createBrowserHistory();

//https://www.youtube.com/watch?v=hjp-JHVsgxQ
//https://github.com/pantharshit00/jwt-react-auth
//https://hptechblogs.com/using-json-web-token-react/
//https://github.com/pantharshit00/jwtAuth


class Login extends Component {
  // constructor(props: Props) {
  //   super(props);
  //   this.state = {
  //     email: "",
  //     password: "",
  //     errorShow: false,
  //     errorMessage: "",
  //     errorColor: ""
  //   };
  //   this.handleSubmit = this.handleSubmit.bind(this);
  // }

  static defaultProps = {
    Auth: new AuthService()
  };

  handleSubmit = (values) => {
    // e.preventDefault();
    // this.props.form.validateFields((err, values) => {
    //   if (!err) {
    //     e.preventDefault();
          this.props.Auth.login(values.username, values.password)
    //     return false;
    //   }
    // });
  };

  render() {
    // const { getFieldDecorator } = this.props.form;
    var nurl = new URL(window.location.href);
    var refUrl = nurl.searchParams.get("service");

    //Чистим куки token при открытии формы логин. Возможны грабли.
    window.document.cookie = 'token=; Max-Age=0; path=/; domain=' + this.props.Auth.getDomainWithoutSubdomain(window.location.href);
    return (
      <div className="login-form">
        <div style={{marginBottom: "25px", textAlign: "center"}}>
          <a href="/">
            <img src="/resources/logo.svg" alt="Logo" />
          </a>
        </div>

        <Form name="normal_login" onFinish={this.handleSubmit} >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Пожалуйста, введите имя пользователя!' }]}
          >
              <Input
                prefix={<UserOutlined/>}
                placeholder="Имя пользователя"
              />
          </Form.Item>
          <Form.Item
            name="password"
            rules={ [{ required: true, message: 'Пожалуйста, введите пароль!' }]}
          >
              <Input.Password
                prefix={<LockOutlined />}
                iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                // type="password"
                placeholder="Пароль"
              />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">
              Войти
            </Button>
            или <a href={(refUrl)?"/app/signup?service="+refUrl:"/app/signup"}>зарегистрироваться!</a>
          </Form.Item>
          <Form.Item>
            <a href="/app/forgot-password">Забыли пароль?</a>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

// const Login = Form.create({ name: 'normal_login' })(NormalLoginForm);
export default Login;